/**
 * Adds smooth, in-page scrolling for any links which contain the 'smooth-scroll' class.
 *
 * Helpers:
 *   Add class `smooth-scroll` to links which link to an in page to have it smooth scroll.
 *
 * @since 0.1.0
 */
import {$body, $window} from './references.js';
import * as adminBar from './admin-bar.js';

// console.log('Site:smooth-scroll');

// TODO: Add target to history so the back button will work

$body.on(
  'click',
  '.smooth-scroll',
  (event) => {
    // console.log('smooth-scroll');

    let offsetValue = 0;

    if (event.target.dataset.offset && event.target.dataset.offset !== '') {
      offsetValue = parseInt(event.target.dataset.offset, 10);
    }

    $window.scrollTo(document.getElementById(event.target.getAttribute('href').substring(1)), {
      offset   : !adminBar.isFixed ? offsetValue : -adminBar.getHeight(),
      duration : 500,
    });

    event.preventDefault();
  },
);
